import { isLocal } from '../localId/localId';
import {
  ADD_LOCAL_COST_CODE_CATEGORY,
  API_CREATE_COST_CODE_CATEGORY,
  API_LOAD_COST_CODE_CATEGORIES,
  API_REMOVE_COST_CODE_CATEGORY,
  API_UPDATE_COST_CODE_CATEGORY,
  REMOVE_LOCAL_COST_CODE_CATEGORY,
} from './costCodeCategory.reducer';

export const load = () => ({ resourceAction: API_LOAD_COST_CODE_CATEGORIES });
export const save = resource => ((isLocal(resource.id)) ? {
  resourceAction: API_CREATE_COST_CODE_CATEGORY,
  resource,
} : { resourceAction: API_UPDATE_COST_CODE_CATEGORY, resource });
export const add = () => ({ type: ADD_LOCAL_COST_CODE_CATEGORY });
export const remove = id => ((isLocal(id)) ? {
  type: REMOVE_LOCAL_COST_CODE_CATEGORY,
  id,
} : { resourceAction: API_REMOVE_COST_CODE_CATEGORY, id });



// WEBPACK FOOTER //
// ./src/reducers/costCodeCategory/costCodeCategory.actions.js